import { CatalogBuilder } from "../../../commonGroupModuleStructure/catalogBuilder";
import { ICatalogBuilder } from "../../../commonGroupModuleStructure/catalogBuilder.entity";
import { getMenuMapping } from "./apiCall";
import { ModulesKeys } from "./entity";


export const ModuleMenuMapping = (props: any) => {
  const { request } = props;

  const columns: ICatalogBuilder['pagingColumns'] = [
    {
      field: "DisplayName",
      headerName: "Display Name",
      editable: false,
      flex: 1,
      minWidth: 130,
      headerAlign: "left",
    },
    // {
    //   field: "ModuleName",
    //   headerName: "Module Name",
    //   editable: false,
    //   flex: 1,
    //   minWidth: 130,
    //   headerAlign: "left",
    // }
  ];

  return (
    <CatalogBuilder
      isHeader={false}
      isPlusButton={false}
      isAssociationButton={true}
      isDefaultActionButton={false}

      getPagingData={getMenuMapping}
      pagingAPIrequest={request}
      pagingAPIKey={ModulesKeys.getMenus}

      pagingColumns={columns}
    />
  );
}   